import config from '../config';
import apiClient from './apiClient';

const getFlashDraw = async() => {
  try {
    const response = await apiClient.get(
      `${config.API_BASE_URL}/flash-draw`
    );
    return response.data;
  } catch (error) {
    console.error(error);
  }
}

export {getFlashDraw};
